// POST the captured sheet to the server rasteriser (Api::CredentialPdfsController).
// Api::BaseController is `null_session`, so a token-less POST would be anonymous and the
// admin guard would bounce it — the CSRF token has to travel with the request.
export async function credentialPdfBlob(pngDataUrl: string): Promise<Blob> {
  const token = document
    .querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
    ?.getAttribute('content');

  const res = await fetch('/api/26/credentials-pdf', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'X-CSRF-Token': token } : {}),
    },
    body: JSON.stringify({ pngDataUrl }),
  });
  if (!res.ok) {
    throw new Error(`Server PDF generation failed: ${res.status}`);
  }
  return res.blob();
}
